import React, { useState, useEffect } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import CodeBattle from './components/CodeBattle';
import Header from './components/Header';
import { Box, Typography, Paper, Alert, Button } from '@mui/material';
import { isApiKeyConfigured } from './services/aiService';
import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#90caf9',
    },
    secondary: {
      main: '#f48fb1',
    },
  },
});

function App() {
  const [apiKeyConfigured, setApiKeyConfigured] = useState(false);
  
  useEffect(() => {
    // 检查是否已配置API密钥
    setApiKeyConfigured(isApiKeyConfigured());
    
    // 定期检查API密钥状态（以防用户配置后不刷新页面）
    const checkInterval = setInterval(() => {
      setApiKeyConfigured(isApiKeyConfigured());
    }, 3000);
    
    return () => clearInterval(checkInterval);
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container maxWidth="lg">
        <Header />
        
        {!apiKeyConfigured && (
          <Paper elevation={3} sx={{ p: 3, mb: 3, bgcolor: 'info.dark' }}>
            <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
              <IntegrationInstructionsIcon sx={{ fontSize: 40, mr: 2, color: 'white' }} />
              <Box>
                <Typography variant="h6" color="white" gutterBottom>
                  欢迎使用CodeFix Battle!
                </Typography>
                <Typography variant="body1" color="white" paragraph>
                  要使用AI生成挑战和评估代码，请点击右上角的设置图标，配置您的OpenAI Router API密钥。
                  如果不配置，系统将使用默认的挑战案例，但AI评估功能将不可用。
                </Typography>
                <Alert severity="info" sx={{ mt: 1 }}>
                  配置API密钥后，您可以根据不同难度生成编程挑战，并获得AI对您代码的深度评估！
                </Alert>
              </Box>
            </Box>
          </Paper>
        )}
        
        <CodeBattle />
      </Container>
    </ThemeProvider>
  );
}

export default App; 